function insertDataWhenElementSelected (editor, data, selectionMeta, selectedElements) {
  if (selectedElements.ids.length > 0) {
    return true;
  }

  return false;
}

export default insertDataWhenElementSelected;
